import angular from 'angular';
import { throttle } from 'lodash';

// A lightweight alternative to http://sroze.github.io/ngInfiniteScroll/, but
// doesn't use jQuery.
//
// Usage:
// infinite-scroll="triggerFn()" threshold="300"
//
// Params:
//   infinite-scroll: The callback function to call when scrolled to the
//     bottom of the element
//   threshold: Trigger when within this distance of the bottom of the element
//
// Uses transclusion to create a child element, which will look like:
//   <div infinite-scroll-container> ... </div>
// This container should be full/unconstrained height, so that scrolling
// happens within the infinite-scroll element.
module.exports = angular.module('common.directives.infinite-scroll', [])
.directive('infiniteScroll', () => {
  return {
    restrict: 'A',
    transclude: true,
    template: '<div infinite-scroll-container><ng-transclude></ng-transclude></div>',
    link: function(scope, element, attrs) {
      var offset = parseInt(attrs.threshold) || 0;
      var containerElement = angular.element(element.children()[0]);

      var throttledOnScroll = throttle(() => {
        if (element.scrollTop() + element.prop('offsetHeight') + offset >=
            containerElement.prop('offsetHeight')) {
          scope.$apply(attrs.infiniteScroll);
        }
      }, 10);

      element.on('scroll', throttledOnScroll);
      scope.$on('$destroy', function() {
        element.off('scroll', throttledOnScroll);
      });
    }
  };
}).name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/infinite-scroll.js
 **/